import React, { Component } from "react";
import PDF from "../CommonPDF/PDF";
import "./RevenueMaster.css";
import "./RevenueTable.css";

import { Input, notification } from "antd";
import Paper from "@material-ui/core/Paper";
import Pdf from "../../Images/pdf.svg";
import Print from "../../Images/print.svg";
import Excel from "../../Images/excel.svg";
import Dialog from "@material-ui/core/Dialog";
import bookic from '../../Images/book_ic.svg';
import Download_icon from '../../Images/Download_icon.svg';
import CloseIcon from "@material-ui/icons/Close";
import tomImg from "../../Images/logo_crop.svg";
import LogoW from "../../Images/tomImgW.svg";
import more from "../../Images/more.svg"
import Tablecomponent from "../../helpers/TableComponent/TableComp";
import DateRangeSelect from "../../helpers/DateRange/DateRange";
import ReactToPrint from "react-to-print";
// import ReactExport from "react-data-export";
import PrintData from "./PrintData";
import { ReactSVG } from "react-svg";
import jsPDF from "jspdf";
import "jspdf-autotable";
import axiosInstance from "../../api/axiosInstance";
import { apiurl, formatMoney } from "../../App";
import dateFormat from "dateformat";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ProfileView from "../TotalOrders/ProfileView";
import Filter from '../../Images/filter.svg';
import AdvanceFilter from "../AdvanceFillter/AdvanceFilter";
import PrescriptionDetailView from "../PrescriptionDetailView/PrescriptionDetailView";
// import PrescriptionDetailView from "../PrescriptionEntry/";
import { withTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Monthpicker from "./mothpicker/Monthpicker";
import moment from 'moment';
import logo from "../../Images/logos.png"
import DateData from "./DateData";
import downloadExcel from "../CommonExcel/Excel"
// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const headRows = [
  { id: "sno", label: "S.No", Columnwidth: 5, typeDt: 'sno' },
  { id: "settlement_date", label: "Settlement Month", type: 'month', Columnwidth: 20, typeDt: 'date' },
  { id: "transaction_count", label: "Transaction", Columnwidth: 15, typeDt: 'amt' },
  { id: "settlement_no", label: "Settlement ID", Columnwidth: 40 },
  { id: "settlement_amount", label: "Receivable", Columnwidth: 25, typeDt: 'amt' },
];

// import { withRouter } from 'react-router-dom';
const ViewReciept = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  height: 410,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "25px",
  outline: "none",
};
class PrintableComponent extends React.Component {
  render() {
    return (
      <div>
        <img className="rs_Downloadimg" src={Download_icon} alt="Download PDF" />
      </div>
    );
  }
}
class RevenueSettlement extends Component {
  constructor(props) {
    super(props);
    this.componentRef = React.createRef();
    this.getMemberDetails = this.getMemberDetails.bind(this);
    this.isshowReceiptClose = this.isshowReceiptClose.bind(this);
    this.state = {
      isMedListPage: false, //
      medListID: 0,//
      props_loading: true,
      TableType: '',
      ToggleRec: '',
      ToggleTotalRec: 'switch',
      Togglepending: '',
      tableData: [],
      revenueTotal: 0,
      revenueTomshare: 0,
      revenuereceived: 0,
      revenuereceivable: 0,
      search: null,
      fromDate: "",
      toDate: "",
      // startDate:"",
      StartDate: "",
      EndDate: "",
      openview: false,
      prescriptionId: null,
      open_filter: false,
      prescriptionopenview: false,
      selected_doctor_id: 0,
      prescriptionEntryData: null,
      isonclickMember: false,
      isMemberId: 0,
      idControl: 'settlement',
      isshowReceipt: false,
      receModelData: {},
      activeSegment: 'KFH',
      selectedReceiptUrl: '',
      toggle_Revenue: '',
      toggle_settlement: 'switch',
      isSettleAdvise: false,
      isSettleAdviseData: {},
      ModelPdfTitle_ref: [],
      respnceRow_Ref: [],
      settlement_DateDt: ''
    };
  }
  componentDidMount() {
    this.handleRouteChange();
  }
  isshowReceiptClose() {
    this.setState({ isshowReceipt: false });
  }
  isSettleAdviseClose = () => {
    // Use setState within a class method
    this.setState({ isSettleAdvise: false });
  };
  handleSegmentClick(type) {
    let selectValue = type === 'KFH' ? this.state.receModelData.kfh_receipt : this.state.receModelData.soa_receipt;
    this.setState({ selectedReceiptUrl: selectValue, activeSegment: type });
    console.log(type);
  }
  handleRouteChange() {
    const { match } = this.props;
    const { id, startDate, endDate } = match.params;
    console.log(id);
    this.setState({ idControl: id, EndDate: endDate, StartDate: startDate }, () => this.handleRadioChange('settlement'));
    // const tableTypes = ["totalrec", "recsof", "balanrec"];
    // if (id && id !== "0" && tableTypes.includes(id)) {
    // this.handleRadioChange(id);
    //  this.setState({ EndDate:endDate ,startDate: startDate}, () => this.handleRadioChange(id));
    // }
    // this.setState({ EndDate: endDate, startDate: startDate }, () =>
    //   this.handleRadioChange('settlement')
    // );
  }
  getMemberDetails(newState) {
    // console.log(newState, "------------------>>>>>>");
    const { memberID, isOnclickMember } = newState;
    this.setState({
      isonclickMember: isOnclickMember,
      isMemberId: memberID,
    });
  }
  getSettlemetList = (id) => {
    this.setState({
      props_loading: true,
    });
    var totalAmount = 0;
    var tomShare = 0;
    var received = 0;
    var receivable = 0;
    var obj_data = {
      "vendorId": localStorage.getItem('pharmacy_id'),
      "p_fromDate": this.state.StartDate,
      "p_toDate": this.state.EndDate,
      // "filterValue": id === 'totalrec' ? '' : (id === 'recsof' ? 'Received' : (id === 'balanrec' ? 'Pending' : '')),
      // "searchElement":""   
    };
    axiosInstance({
      method: "POST",
      url: apiurl + "revenueSettlement/settlementRevenue",
      data: obj_data,
    })
      .then((response) => {
        if (response.data.status == 1) {
          if (response.data.data.length > 0) {
            totalAmount = response.data.data.map(item => item.settlement_amount).reduce((acc, curr) => acc + curr, 0);
            tomShare = response.data.data.map(item => item.tomShare).reduce((acc, curr) => acc + curr, 0);
            received = response.data.data.map(item => item.inCome).reduce((acc, curr) => acc + curr, 0);
            receivable = response.data.data.map(item => item.inCome).reduce((acc, curr) => acc + curr, 0);
            this.setState({
              props_loading: false,
              tableData: response.data.data,
              // enableSearch: false,
              revenueTotal: totalAmount,
              revenueTomshare: tomShare,
              revenuereceived: received,
              revenuereceivable: receivable
            });
          }
          else {
            this.setState({
              props_loading: false,
              tableData: [],
              revenueTotal: 0,
              revenueTomshare: 0,
              revenuereceived: 0,
              revenuereceivable: 0
            })
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //   getRevenueMedList = () =>{
  //     this.setState({
  //       props_loading: true,
  //     });
  //     var totalAmount=0;
  //     var totaltomshare=0;
  //     var totalFee=0;
  //     var obj_data = {
  //         "prescriptionId": this.state.medListID,
  //         "searchElement": ""  
  //     };
  //     debugger
  //     axiosInstance({
  //       method: "POST",
  //       url: apiurl + "pharmacy/getPharmacyMedList",
  //       data: obj_data,
  //     })
  //       .then((response) => {
  //         if (response.data.status == 1) {
  //           if (response.data.data.length > 0) {        
  //             debugger
  //             totalAmount = response.data.data.map(item => item.amount).reduce((acc, curr) => acc + curr, 0);
  //             totaltomshare = response.data.data.map(item => item.tomShare).reduce((acc, curr) => acc + curr, 0);
  //             totalFee = response.data.data.map(item => item.unit_rate).reduce((acc, curr) => acc + curr, 0);
  //             this.setState({
  //               props_loading: false,
  //               tableData: response.data.data,
  //               // enableSearch: false,
  //               revenueTotal: totalAmount,
  //               revenueTomshare:totaltomshare,
  //               revenueFee:totalFee
  //             });
  //           }
  //       }})
  //       .catch((error) => {
  //         console.log(error);
  //     });
  //   }
  getRangeDate = (item) => {
    DateData.setdate(dateFormat(item[0].endDate, "yyyy-mm-dd"), dateFormat(item[0].startDate, "yyyy-mm-dd"), false, this.state.idControl)
    this.setState(
      {
        // fromDate: dateFormat(item[0].startDate, "yyyy-mm-dd"),
        // toDate: dateFormat(item[0].endDate, "yyyy-mm-dd"),
        EndDate: dateFormat(item[0].endDate, "yyyy-mm-dd"),
        StartDate: dateFormat(item[0].startDate, "yyyy-mm-dd"),
        idControl: 'settlementkw'
      },
      () => this.getSettlemetList(this.state.tabletype)
    );
  };
  // data has empty this alert msg showed print pdf excel   
  Notification = () => {
    notification.warning({
      message: "No data found",
      placement: "topRight",
    });
  };

  searchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
  };
  modelReceiptopen = (data) => {
    this.setState({
      isshowReceiptData: data?.soa_receipt,
      isshowReceipt: true,
    });
  }
  modelopen = (data, id) => {
    const membersettlement = [
      { id: 's_no', label: 'S.No' },
      { id: 'booked_date', label: 'Date', type: 'date' },
      { id: 'name', label: 'Member', type: 'name' },
      { id: 'paymentType', label: 'Payment', type: 'name' },
      { id: 'fee', label: 'Fee', type: 'amt' },
      { id: 'tomTotalShare', label: (<div><img style={{ width: '18px' }} src={LogoW} /> Share</div>), type: 'amt' },
      { id: '', label: 'Debit', type: '' },
      { id: 'pharmacyRevenue', label: 'Credit', type: 'amt' },
      { id: 'balance', label: 'Balance', type: 'amt' },
    ];
    this.setState({ ModelPdfTitle_ref: membersettlement });
    // if (data === "view") {
    //   var booking_idee = { booking_id: id };
    //   debugger;
    var obj = {
      "typeID": 9,
      "p_vendorId": localStorage.getItem("pharmacy_id"),
      "p_settlementNo": id.settlement_no,
      // "filter_value": "",
      // "searchContent": "",
      // "payable_type": '',
    }
    axiosInstance({
      method: "POST",
      url: apiurl + "revenueSettlement/getTomRevenueListC",
      // url: apiurl + "/Pharmacy/getParticularPharmRevenueList",
      data: obj,
    })
      .then((response) => {
        if (response.data.data.length > 0) {
          this.setState({
            respnceRow_Ref: response.data.data
          });
        } else {
          this.setState({
            respnceRow_Ref: []
          });
        }
      }
      )
      .catch((error) => {
        console.log(error);
      });
    this.setState({
      // OpenViewData: booking_idee,
      // openview: true,
      isSettleAdvise: true,
      isSettleAdviseData: id
    });
    // }
  };
  handleClose = () => {
    this.setState({ openview: false });
  };
  openAdvanceFilter = () => {
    this.setState({ open_filter: true })
  }
  closeAdvanceFilter = () => {
    this.setState({ open_filter: false })
  }
  getTableData = () => {
    // axios({
    // method: "POST",
    // url: apiurl + "pharmacy/getPharamacyRevenue",
    // data: {
    //   pharmacy_id: localStorage.pharmacy_id ? localStorage.pharmacy_id : 0,
    //   prescription_date: this.state.fromDate,
    //   prescription_date_to: this.state.toDate,
    //   doctor_id: this.state.selected_doctor_id
    // },
    // })
    //   .then((response) => {                               
    var tableData = [{ orderId: 1, customer: 'ram', doctorName: 'doctor', clinicName: 'clinic', date: '2023-11-10', totalCharge: 100 },
    { orderId: 1, customer: 'ram', doctorName: 'doctor', clinicName: 'clinic', date: '2023-11-10', totalCharge: 100 },
    { orderId: 1, customer: 'ram', doctorName: 'doctor', clinicName: 'clinic', date: '2023-11-10', totalCharge: 100 },
    { orderId: 1, customer: 'ram', doctorName: 'doctor', clinicName: 'clinic', date: '2023-11-10', totalCharge: 100 },
    { orderId: 1, customer: 'ram', doctorName: 'doctor', clinicName: 'clinic', date: '2023-11-10', totalCharge: 100 },
    { orderId: 1, customer: 'ram', doctorName: 'doctor', clinicName: 'clinic', date: '2023-11-10', totalCharge: 100 }];
    // response.data.data.result.map((val) => {
    //   tableData.push({
    //     orderId:val.custom_order_id,
    //     customer: val.customer,
    //     doctorName: val.doctor_name,
    //     clinicName: val.clinic_name,
    //     date: dateFormat(val.approval_date, "dd-mmm-yy"),
    //     totalCharge: val.total_amount,
    //     id: val.patient_id,
    //     prescription_id: val.prescription_id,
    //     pharmacyId: localStorage.pharmacy_id ? localStorage.pharmacy_id : 0,
    //     order_id:val.order_id
    //   });
    // });
    var totalAmount = 200;
    // for (var i in response.data.data.result) {
    //   totalAmount = response.data.data.result[i].total_amount + totalAmount;
    // }
    this.setState({
      props_loading: false,
      tableData: tableData,
      // enableSearch: false,          
      revenueTotal: totalAmount,
    });
    // this.setState({});
    // })
    // .catch((error) => {});
  }
  submitAdvanceFilter = (selected_doctor_id) => {
    this.setState({ selected_doctor_id, open_filter: false }, () => {
      this.getTableData();
    })
  }
  handleRadioChange = (event) => {
    const toggle = event.target ? event.target.value : event;
    // debugger
    // this.setState({ ToggleValue: toggle},()=>this.fetchData(toggle));
    const { history } = this.props;
    this.setState({ TableType: toggle });
    // if(toggle == "totalrec"){
    //   this.setState({ToggleTotalRec:'switch',ToggleRec:'',Togglepending:''});
    //   history.push(`/home/revenueChart/settlement/${this.state.startDate}/${this.state.EndDate}/totalrec`);                 
    // }else if(toggle === "recsof"){
    //   this.setState({ToggleTotalRec:'',ToggleRec:'switch',Togglepending:''});
    //   history.push(`/home/revenueChart/settlement/${this.state.startDate}/${this.state.EndDate}/recsof`);                 
    // }else if(toggle === "balanrec"){
    //   this.setState({ToggleTotalRec:'',ToggleRec:'',Togglepending:'switch'});
    //   history.push(`/home/revenueChart/settlement/${this.state.startDate}/${this.state.EndDate}/balanrec`);                 
    // }
    if (toggle == "revenue") {
      this.setState({
        toggle_Revenue: 'switch',
        toggle_settlement: '',
      });
      DateData.setdate(this.state.StartDate, this.state.EndDate, false, 'settlementkw')
      history.push(
        `/home/revenueChart/revenue/${this.state.StartDate ? this.state.StartDate : 0}/${this.state.EndDate ? this.state.EndDate : 0}/${this.state.idControl}/${DateData.item.pagenav}`
      );
    } else if (toggle === "settlement") {
      this.setState({
        toggle_Revenue: '',
        toggle_settlement: 'switch',
        // idControl:this.state.idControl
      });
      // DateData.setdate(this.state.StartDate,this.state.EndDate,'false','settlementkw')
      // history.push(
      //   `/home/revenueChart/settlement/${this.state.startDate ? this.state.startDate : 0}/${this.state.EndDate ? this.state.EndDate : 0}/${this.state.idControl ? this.state.idControl : 0}`
      //   // `/home/revenueChart/settlement/${this.state.startDate}/${this.state.EndDate}/recsof`
      // );
    }
    this.setState({ TableType: toggle }, () => this.getSettlemetList(toggle));
  }
  render() {
    const { Search } = Input;
    const { t } = this.props;
    // const total_heading = ((localStorage.pharmacy_language == 'ar') ?
    //   [
    //     {
    //       id: "soa_receipt",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           {/* {t("Room Type")} */}
    //           {t("KFH_Statement")}
    //         </span>
    //       ), typeDt: 'amt'
    //     },
    //     {
    //       id: "settlement_amount",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           {/* {t("tbl_head_member")} */}
    //           <span><span style={{ fontSize: '10px' }}>{t("kwd")}</span> {t("tbl_receivable")} </span>
    //           {/* {'Receivable (INR)'} */}
    //         </span>
    //       ), typeDt: 'amt'
    //     },
    //     {
    //       id: "settlement_no",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           {t("tbl_settlement_id")}
    //         </span>
    //       ), typeDt: 'str'
    //     },
    //     {
    //       id: "transaction_count",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           {/* {t("Date")} */}
    //           {t("transaction")}
    //         </span>
    //       ), typeDt: 'amt'
    //     },
    //     {
    //       id: "settlement_date",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           {t("Settlement_Date")}
    //         </span>
    //       ), typeDt: 'date'
    //     },
    //     {
    //       id: "sno",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           {t("tbl_head_s_no")}
    //         </span>
    //       ), typeDt: 'sno'
    //     },
    //   ] :
    //   [
    //     {
    //       id: "sno",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "start" }}>
    //           {t("tbl_head_s_no")}
    //         </span>
    //       ), typeDt: 'sno'
    //     },
    //     {
    //       id: "settlement_date",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           {"Settlement Month"}
    //         </span>
    //       ), typeDt: 'date'
    //     },
    //     {
    //       id: "transaction_count",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           {/* {t("Date")} */}
    //           {"Transaction"}
    //         </span>
    //       ), typeDt: 'amt'
    //     },
    //     {
    //       id: "settlement_no",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           {t("tbl_settlement_id")}
    //         </span>
    //       ), typeDt: 'str'
    //     },
    //     {
    //       id: "settlement_amount",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           <span>{t('tbl_receivable')} </span>
    //         </span>
    //       ), typeDt: 'amt'
    //     },
    //     {
    //       id: "soa_receipt",
    //       label: (
    //         <span style={{ display: "flex", justifyContent: "center" }}>
    //           {'KFH Statement'}
    //         </span>
    //       ), typeDt: 'amt'
    //     },
    //   ]
    // )

    const total_heading = ((localStorage.training_center_language == 'ar') ? [
      { id: "kfhstatement", label: t("KFH_Statement"), typeDt: 'amt' },
      { id: "inCome", label: t("tbl_receivable"), typeDt: 'amt' },
      { id: "settlement_no", label: t("tbl_settlement_id"), typeDt: 'str' },
      { id: "transaction", label: t("transaction"), typeDt: 'amt' },
      { id: "settlement_month", label: t("Settlement_Date"), typeDt: 'date' },
      { id: "sno", label: t("tbl_head_s_no"), typeDt: 'sno' }
    ] : [
      { id: "sno", label: t("tbl_head_s_no"), typeDt: 'sno' },
      { id: "settlement_month", label: t("Settlement_Date"), typeDt: 'date' },
      { id: "transaction", label: t("transaction"), typeDt: 'amt' },
      { id: "settlement_no", label: t("tbl_settlement_id"), typeDt: 'str' },
      { id: "inCome", label: t("tbl_receivable"), typeDt: 'amt' },//t("tbl_head_Income")
      { id: "kfhstatement", label: t("KFH_Statement"), typeDt: 'amt' },
    ]);

    const recevied_heading =
      localStorage.pharmacy_language == "ar"
        ? [
          { id: "tomShare", label: t("tbl_head_approval_received_on") },
          { id: "unit", label: t("tbl_head_doctor") },
          { id: "name", label: t("tbl_head_member") },
          { id: "prescript_date", label: t("tbl_head_id") },
          { id: "sno", label: t("tbl_head_s_no") },
        ]
        : [
          {
            id: "sno",
            label: (
              <span style={{ display: "flex", justifyContent: "start" }}>
                {t("tbl_head_s_no")}
              </span>
            ),
          },
          {
            id: "prescript_date",
            label: (
              <span style={{ display: "flex", justifyContent: "center" }}>
                {t("Date")}
              </span>
            ),
          },
          {
            id: "settlement_no",
            label: (
              <span style={{ display: "flex", justifyContent: "center" }}>
                {t("Settlement ID")}
              </span>
            ),
          },
          {
            id: "name",
            label: (
              <span style={{ display: "flex", justifyContent: "" }}>
                {t("tbl_head_member")}
              </span>
            ),
          },
          {
            id: "roomType",
            label: (
              <span style={{ display: "flex", justifyContent: "" }}>
                {t("Room Type")}
              </span>
            ),
          },
          {
            id: "fee",
            label: (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {`${t("Fee")} `}{" "}
                <span
                  style={{
                    fontSize: "10px",
                    marginBottom: "-3px",
                    paddingLeft: "2px",
                  }}
                >{`(${t("INR")})`}</span>
              </span>
            ),
          },
          {
            id: "tomShare",
            label: (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <sapn style={{ display: 'flex', alignItems: 'end' }}><img style={{ height: '15px', position: 'relative', bottom: "2px" }} src={logo}></img> Share</sapn>
                <span
                  style={{
                    fontSize: "10px",
                    marginBottom: "-3px",
                    paddingLeft: "2px",
                  }}
                >{`(${t("INR")})`}</span>
              </span>
            ),
          },
          {
            id: "inCome",
            label: (
              <span style={{ display: "flex", justifyContent: "center" }}>
                {t("Received so far")}{" "}
                <span
                  style={{
                    fontSize: "10px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "2px",
                    paddingTop: "3px",
                  }}
                >{`(${t("INR")})`}</span>
              </span>
            ),
          },
          {
            id: "Received",
            label: (
              <span style={{ display: "flex", justifyContent: "center" }}>
                {t("Receipt Status")}{" "}
              </span>
            ),
          },
        ];
    const pending_heading = ((localStorage.pharmacy_language == 'ar') ? [
      { id: "tomShare", label: t("tbl_head_approval_received_on") },
      { id: "unit", label: t("tbl_head_doctor") },
      { id: "name", label: t("tbl_head_member") },
      { id: "prescript_date", label: t("tbl_head_id") },
      { id: "sno", label: t("tbl_head_s_no") },
    ] : [
      { id: "sno", label: (<span style={{ display: 'flex', justifyContent: 'start' }}>{t("tbl_head_s_no")}</span>) },
      { id: "prescript_date", label: (<span style={{ display: 'flex', justifyContent: 'center' }}>{t("tbl_head_ticket_date")}</span>) },
      { id: "name", label: (<span style={{ display: 'flex', justifyContent: '' }}>{t("tbl_head_member")}</span>) },
      { id: "fee", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{`${t("tbl_head_fees")} `} <span style={{ fontSize: '10px', marginBottom: '-3px', paddingLeft: '2px' }}>{`(${t("kwd")})`}</span></span>) },
      { id: "tomShare", label: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{`${t("tbl_head_tomshare")} `} <span style={{ fontSize: '10px', marginBottom: '-3px', paddingLeft: '2px' }}>{`(${t("kwd")})`}</span></span>) },
      { id: "inCome", label: (<span style={{ display: 'flex', justifyContent: 'center' }}>{t("tbl_receivable")}</span>) },
    ])
    var searchData = [];
    var searchData1 = [];
    this.state.tableData.filter((data) => {
      if (this.state.search === null) {
        if (this.state.TableType === "settlement") {
          searchData.push({
            settlement_month: (
              <span style={{ display: "flex", justifyContent: "center" }}>
                {moment(data.settlement_date).format('MMM-YY')}
              </span>
            ),
            transaction_count: (
              <span style={{ display: "flex", justifyContent: "center" }}>
                {data.transaction_count}
              </span>
            ),
            settlement_no: (
              <span style={{ display: "flex", justifyContent: "center" }}>
                {data.settlement_no ? data.settlement_no : "-"}
              </span>
            ),
            settlement_amount: (
              <span
                style={{
                  display: "flex",
                  gap: '10px',
                  justifyContent: "center",
                  direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : '')
                }}
              >
                {/* <p style={{ margin: '0', width: '60%', textAlign: 'right' }}>{formatMoney(data.settlement_amount)}</p> */}
                <p style={{
                  margin: (localStorage.pharmacy_language == 'ar' ? '' : '0'),
                  width: (localStorage.pharmacy_language == 'ar' ? '' : '60%'),
                  textAlign: (localStorage.pharmacy_language == 'ar' ? '' : 'right'),
                  paddingRight: (localStorage.pharmacy_language == 'ar' ? '47px' : '')
                }}>{formatMoney(data.settlement_amount)}</p>
                <img
                  style={{
                    paddingRight: (localStorage.pharmacy_language == 'ar' ? '0px' : '')
                  }}
                  src={more}
                  className="tableeye_icon ccpR"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.modelopen("view", data);
                  }}
                />
              </span>
            ),
            soa_receipt: (
              <span style={{ display: "flex", justifyContent: "center" }}>
                {data.soa_receipt ? <img src={more} className="tableeye_icon" onClick={(e) => {
                  e.stopPropagation();
                  this.modelReceiptopen(data);
                }}
                /> : '-'}
              </span>
            ),
            id: data.id,
          });
          searchData1.push({
            settlement_date: data.settlement_date,
            transaction_count: data.transaction_count,
            settlement_no: data.settlement_no,
            settlement_amount: data.settlement_amount,
          });
        }
        else if (this.state.TableType === "totalrec") {
          searchData.push({
            prescript_date: (<span style={{ display: 'flex', justifyContent: 'center' }}>{dateFormat(data.prescript_date, "d-mmm-yy")}</span>),
            settlement_no: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.settlement_no}</span>),
            name: (<span style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}> {data.name}<img src={more} className="tableeye_icon" onClick={(e) => { e.stopPropagation(); this.modelopen("view", data.id); }} /></span>),
            fee: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.fee}</span>),
            tomShare: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.tomShare}</span>),
            inCome: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.inCome}</span>),
            paymentStatus: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.paymentStatus}</span>),
            id: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.id}</span>)
          })
        } else if (this.state.TableType === "recsof") {
          searchData.push({
            prescript_date: (<span style={{ display: 'flex', justifyContent: 'center' }}>{dateFormat(data.prescript_date, "d-mmm-yy")}</span>),
            settlement_no: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.settlement_no}</span>),
            name: (<span style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}> {data.name}<img src={more} className="tableeye_icon" onClick={(e) => { e.stopPropagation(); this.modelopen("view", data.id); }} /></span>),
            fee: (<span style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>{data.fee}</span>),
            tomShare: (<span style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>{data.tomShare}</span>),
            inCome: (<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}> {data.inCome}</span>),//data.inCome,
            id: data.id
          })
        } else if (this.state.TableType === "balanrec") {
          searchData.push({
            prescript_date: (<span style={{ display: 'flex', justifyContent: 'center' }}>{dateFormat(data.prescript_date, "d-mmm-yy")}</span>),
            name: (<span style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}> {data.name}<img src={more} className="tableeye_icon" onClick={(e) => { e.stopPropagation(); this.modelopen("view", data.id); }} /></span>),
            fee: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.fee}</span>),
            tomShare: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.tomShare}</span>),
            inCome: (<span style={{ display: 'flex', justifyContent: 'center' }}>{data.inCome}</span>),
            id: data.id
          })
        }
      }
      // else if (
      //   (data.customer !== null &&
      //     data.customer
      //       .toLowerCase()         
      //       .includes(this.state.search.toLowerCase())) ||
      //   (data.doctorName != null &&    
      //     data.doctorName
      //       .toLowerCase()    
      //       .includes(this.state.search.toLowerCase())) ||
      //   (data.date != null &&
      //     data.date
      //       .toString()      
      //       .toLowerCase()   
      //       .includes(this.state.search.toString()))   
      // ) {
      //   searchData.push({
      // orderId:data.orderId,
      // customer: (
      //   <> <span>{`${data.customer}`}</span><img src={more}
      //     className="tableeye_icon"
      //     onClick={() => {
      //       this.modelopen("view", data.prescription_id);
      //     }}    
      //   /></>                 
      // ),
      // doctorName: data.doctorName,
      // date: data.date,
      // totalCharge: data.totalCharge,
      // total: data.total,
      // action: (
      //   <img src={more}
      //     className="tableeye_icon"
      //     onClick={() => {
      //       this.modelopen("view", data.prescription_id);
      //     }}
      //   />
      // ),
      // id: data.id,
      // });
      // }
    });
    // EXCEL FUNCTION
    var multiDataSetbody = [];
    this.state.tableData.map((xldata, index) => {
      if (index % 2 !== 0) {
        if (this.state.TableType === "totalrec" || this.state.TableType === "recsof") {
          multiDataSetbody.push([
            { value: index + 1, style: { alignment: { horizontal: "center" } } },
            { value: xldata.payment_date },
            { value: xldata.settlement_no },
            { value: xldata.name },
            { value: xldata.fee },
            { value: xldata.tomShare },
            { value: xldata.inCome },
            {
              value: xldata.paymentStatus,
              style: { alignment: { horizontal: "center" } },
            },
          ]);
        } else {
          multiDataSetbody.push([
            { value: index + 1, style: { alignment: { horizontal: "center" } } },
            { value: xldata.payment_date },
            { value: xldata.name },
            { value: xldata.fee },
            { value: xldata.tomShare },
            {
              value: xldata.inCome,
              style: { alignment: { horizontal: "center" } },
            },
          ]);
        }
      } else {
        if (this.state.TableType === "totalrec" || this.state.TableType === "recsof") {
          multiDataSetbody.push([
            {
              value: index + 1,
              style: {
                alignment: { horizontal: "center" },
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.payment_date,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.settlement_no,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.name,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.fee,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.tomShare,
              style: {
                alignment: { horizontal: "center" },
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.inCome,
              style: {
                alignment: { horizontal: "center" },
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.paymentStatus,
              style: {
                alignment: { horizontal: "center" },
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
          ]);
        } else {
          multiDataSetbody.push([
            {
              value: index + 1,
              style: {
                alignment: { horizontal: "center" },
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.payment_date,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.name,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.fee,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.tomShare,
              style: {
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
            {
              value: xldata.inCome,
              style: {
                alignment: { horizontal: "center" },
                fill: { patternType: "solid", fgColor: { rgb: "e2e0e0" } },
              },
            },
          ]);
        }
      }
    });
    const multiDataSet = [
      {
        columns: [
          {
            title: "S.No",
            width: { wpx: 35 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: "Date",
            width: { wch: 20 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: "Member",
            width: { wch: 20 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: "Fee (INR)",
            width: { wch: 20 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: "tom share (INR)",
            width: { wpx: 100 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
          {
            title: "Receivable",
            width: { wpx: 100 },
            style: {
              fill: { patternType: "solid", fgColor: { rgb: "86b149" } },
            },
          },
        ],
        data: multiDataSetbody,
      },
    ];

    return (
      <div>
        <Paper>
          <div className="uploadsmasterheader revenue_head_div">
            {/* <div className="titlerevenue">{`SETTLEMENT ${new Date(this.state.StartDate).getMonth() == new Date(this.state.EndDate).getMonth() ? */}
            <div className="titlerevenue">{`${t('settlementof')} ${new Date(this.state.StartDate).getMonth() == new Date(this.state.EndDate).getMonth() ?
              '- ' + new Date(this.state.StartDate).toLocaleDateString('en-US', { month: 'short' }).toUpperCase() + "  " + new Date(this.state.StartDate).getFullYear() % 100
              : '- ' + new Date(this.state.StartDate).toLocaleDateString('en-US', { month: 'short' }).toUpperCase() + "  " + new Date(this.state.StartDate).getFullYear() % 100 + " - " +
              new Date(this.state.EndDate).toLocaleDateString('en-US', { month: 'short' }).toUpperCase() + "  " + new Date(this.state.EndDate).getFullYear() % 100}`}</div>
            <div
              style={{
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
              }}
              className="range_picker_reduce"
            >
              {this.state.StartDate &&
                <div className={`${this.props.i18n.language == 'ar' ? "order_3" : ""} `}>
                  {/* <DateRangeSelect
   revenueRange
   dynalign={"dynalign"}
   rangeDate={(item) => this.getRangeDate(item)}
   t={t}
   i18n={this.props.i18n}
 /> */}
                  <Monthpicker
                    s_month={this.state.idControl == 1 || this.state.idControl == 'settlementkw' ? moment(this.state.StartDate).add('year').format('YYYY-MM') : ''}
                    rangeDate={(item) => this.getRangeDate(item)} />
                </div>
              }
              <ReactSVG
                src={Filter}
                style={{ marginRight: "15px", marginLeft: "15px" }}
                onClick={this.openAdvanceFilter}
                className={`${this.props.i18n.language == 'ar' ? "order_2" : ""} `}
              />
              <Search
                placeholder="Search"
                onChange={(e) => this.searchChange(e)}
                style={{ width: 150 }}
                className={`${this.props.i18n.language == 'ar' ? "order_1" : ""} mr-2 ml-2`}
              />

              <div className={`${this.props.i18n.language == 'ar' ? "order_0" : ""} icon_head`}
                style={{ direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : '') }}>
                <PDF
                  weekMonthYearData={this.state.tableData}
                  headRows={headRows}
                  filename={"Settlement Details"}
                  headingTitle={'Settlement Details'}
                  type={"settlement"}
                  HeadingButton1={[{ revenueTotal: this.state.revenueTotal.toFixed(2), }]}
                  lang={this.props.i18n.language}
                />
                {/* {this.state.tableData.length === 0 ? (
                  <ReactSVG
                    onClick={this.Notification}
                    src={Excel}
                    style={{ marginRight: "15px", marginLeft: (localStorage.pharmacy_language == 'ar' ? '15px' : '') }}
                  />
                ) : (
                  <ExcelFile
                    filename={"Revenue_Details"}
                    element={
                      <ReactSVG src={Excel} style={{ marginRight: "15px",marginLeft: (localStorage.pharmacy_language == 'ar' ? '15px' : '') }} />
                    }
                  >
                    <ExcelSheet dataSet={multiDataSet} name="Revenue Details" />
                  </ExcelFile>
                )} */}
                <img
                  onClick={() => {
                    downloadExcel('Settlement', searchData1, headRows, '', [
                      { income: '' },
                      { income: '' },
                      { income: '' },
                      { income: 'Total' },
                      { income: this.state.revenueTotal.toFixed(2) },
                    ])
                  }}
                  src={Excel}
                  style={{ cursor: 'pointer' }}
                />

                {this.state.tableData.length === 0 ? (
                  <ReactSVG src={Print} onClick={this.Notification} />
                ) : (
                  <ReactToPrint
                    trigger={() => <ReactSVG src={Print} />}
                    content={() => this.componentRef}
                  />
                )}
                <div style={{ display: "none" }}>
                  <PrintData
                    printTableData={this.state.tableData}
                    ref={(el) => (this.componentRef = el)}
                    type={this.state.TableType}
                    HeadingButton={[{ revenueTotal: this.state.revenueTotal.toFixed(2), }]}
                  />
                </div>
              </div>



            </div>
          </div>

          <div className="revenue-master-table">
            <div className="toggler mt-4" style={{ direction: (localStorage.pharmacy_language == 'ar' ? 'rtl' : '') }}>
              <div className="switches-container">
                <input
                  type="radio"
                  id="revenue1"
                  name="switchPlan"
                  value="revenue"
                  checked="checked"
                  onChange={this.handleRadioChange}
                />
                <label htmlFor="revenue1" className={this.state.toggle_Revenue}>
                  {/* Revenue */}
                  {t('revenue_with_kwd')}
                </label>
                <input
                  type="radio"
                  id="pharma"
                  name="switchPlan"
                  value="settlement"
                  onChange={this.handleRadioChange}
                />
                <label htmlFor="pharma" className={this.state.toggle_settlement}>
                  {/* Settlement */}
                  {t('settleof')}
                </label>
                {/* <input
                  type="radio"
                  id="tomshare"
                  name="switchPlan"
                  value="balanrec"
                  onChange={this.handleRadioChange}
                />
                <label htmlFor="tomshare" className={this.state.Togglepending}>
                  Balance Receivable
                </label> */}
              </div>
            </div>
            <div className="allkwd_lbl" style={{
              padding: (localStorage.pharmacy_language == 'ar' ? '1rem 33px 0 33px' : '1rem 33px 0 0'),
              textAlign: (localStorage.pharmacy_language == 'ar' ? 'start' : '')
            }}>
              {/* All values in INR */}
              {t('all_values_in_kwd')}
            </div>
            {this.state.TableType === "settlement" &&
              <Tablecomponent
                type="revenue"
                oncliking="RevenueAndSettlement"
                memberID={this.state.isMemberId}
                isonclickMember={this.state.isonclickMember}
                isHeadingButton={true}
                HeadingButton={((localStorage.pharmacy_language == 'ar') ?
                  ["", { label: `${this.state.revenueTotal?.toFixed(2)}` }]
                  :
                  ["", "", "", "", { label: `${this.state.revenueTotal?.toFixed(2)}` }]
                )}
                getMemberDetails={this.getMemberDetails}
                heading={total_heading}
                rowdata={searchData}
                DataFound={moment(this.state.StartDate).format('MM') == moment().format('MM') ? <div>Monthly settlement advise will be generated by 1<sup>st</sup> of next month</div> : t("no_data_found")}
                tableicon_align={""}
                modelopen={(e) => this.modelopen(e)}
                actionclose="close"
                EditIcon="close"
                DeleteIcon="close"
                VisibilityIcon="close"
                grandtotal="total"
                props_loading={this.state.props_loading}
                modeprop
                t={t}
                i18n={this.props.i18n}
              />
            }
            {this.state.TableType === "recsof" &&
              <>            <Tablecomponent
                type="revenue"
                oncliking="RevenueAndSettlement"
                memberID={this.state.isMemberId}
                isonclickMember={this.state.isonclickMember}
                isHeadingButton={true}
                HeadingButton={["", "", "", "", "", "", { label: `${this.state.revenuereceived.toFixed(2)}` }]}
                getMemberDetails={this.getMemberDetails}
                heading={recevied_heading}
                rowdata={searchData}
                tableicon_align={""}
                modelopen={(e) => this.modelopen(e)}
                actionclose="close"
                EditIcon="close"
                DeleteIcon="close"
                VisibilityIcon="close"
                grandtotal="total"
                props_loading={this.state.props_loading}
                modeprop
                t={t}
                i18n={this.props.i18n}
              />
                {/* <div className="revenueTotal">
          <span> {t("total_income_with_colon")} {`${this.state.revenueTotal.toFixed(2)}`} <span className="font_10">INR</span></span>
          </div> */}
              </>
            }
            {
              this.state.TableType === "balanrec" &&
              <Tablecomponent
                type="revenue"
                oncliking="RevenueAndSettlement"
                memberID={this.state.isMemberId}
                isonclickMember={this.state.isonclickMember}
                isHeadingButton={true}
                HeadingButton={["", "", "", "", "", { label: `${this.state.revenuereceivable.toFixed(2)}` }]}
                getMemberDetails={this.getMemberDetails}
                heading={pending_heading}
                rowdata={searchData}
                tableicon_align={""}
                modelopen={(e) => this.modelopen(e)}
                actionclose="close"
                EditIcon="close"
                DeleteIcon="close"
                VisibilityIcon="close"
                grandtotal="total"
                props_loading={this.state.props_loading}
                modeprop
                t={t}
                i18n={this.props.i18n}
              />
            }
          </div>
        </Paper>
        {/* {this.state.openview ? (
          <ProfileView
            open={this.state.openview}
            onClose={this.handleClose}
            xswidth={"xs"}
            profileData={this.state.profileData}
            getTableData={() => this.getTableData()}
            isFrom="revenueTable"
          />
        ) : null} */}
        {this.state.prescriptionopenview && (
          <PrescriptionDetailView
            prescriptionopenview={this.state.prescriptionopenview}
            onClose={this.handleClose}
            xswidth={"xs"}
            prescriptionEntryData={this.state.prescriptionEntryData}
            getTableData={() => this.getTableData()}
            is_from_revenue={true}
            t={t}
            i18n={this.props.i18n}
            fromData="revenuedetails"
          />
        )}
        <AdvanceFilter open={this.state.open_filter}
          onClose={this.closeAdvanceFilter}
          submitAdvanceFilter={this.submitAdvanceFilter}
          t={t}
          i18n={this.props.i18n}
        />
        <Dialog
          onClose={this.isshowReceiptClose}
          open={this.state.isshowReceipt}
          maxWidth={"md"}
          fullWidth={true}
          // disableBackdropClick={true}
          aria-labelledby="simple-dialog-title"
          className={`${this.props.i18n.language == "ar" ? "arabic_cls" : ""
            } revenue_Model`} //prescription_popup
          style={{ width: "450px", margin: "auto", height: '350px' }}
        >
          <div>
            <div sx={ViewReciept}>
              <div className="rs_Model_crd d-flex justify-content-around">
                <div className="rs_model_title">
                  View Receipt
                  <CloseIcon
                    className="rs_close_icon"
                    onClick={this.isshowReceiptClose}
                  ></CloseIcon>
                </div>
              </div>
              {/* <div className="d-flex justify-content-end container p-4 ">
                <ReactToPrint
                  trigger={() => (
                    <img
                      className="rs_Downloadimg"
                    // src={Download_icon}
                    ></img>
                  )}
                  content={() => this.componentRef.current}
                />
                <PrintableComponent ref={this.componentRef} />
              </div> */}
              <div className="d-flex justify-content-end" style={{ padding: '10px 45px 3px', fontSize: '12px', fontWeight: '500' }}>Uploaded Date : {moment(this.state.settlementDate).format('DD-MMM-YY')}</div>
              <div className="p-2 d-flex justify-content-center  rsframe mb-5">
                <iframe
                  className="rs_frame"
                  src={this.state.isshowReceiptData}
                />
              </div>
              {/* <div className="container d-flex justify-content-center p-4">
                <div
                  className={`rs_segment_line ${this.state.activeSegment === "KFH" ? "rs_active" : ""
                    }`}
                  onClick={() => this.handleSegmentClick("KFH")}
                >
                  <div className="w-100 d-flex justify-content-center">
                    KFH SOA
                  </div>
                </div>
                <div
                  className={`rs_segment_line ${this.state.activeSegment === "tom" ? "rs_active" : ""
                    }`}
                  onClick={() => this.handleSegmentClick("tom")}
                >
                  <div className="w-100 d-flex justify-content-center">
                    tom SOA
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </Dialog>
        <Dialog
          onClose={this.isSettleAdviseClose}
          open={this.state.isSettleAdvise}
          maxWidth={"md"}
          fullWidth={true}
          // disableBackdropClick={true}
          aria-labelledby="simple-dialog-title"
          className={`${this.props.i18n.language == "ar" ? "arabic_cls" : ""
            } revenue_Model`} //prescription_popup
          style={{ width: "65%", margin: "0 auto" }}
        >
          <div style={{ overflow: 'hidden' }}>
            {/* <Box sx={styleforModle1}> */}
            {/* <PDFDownloadLink document={<PdfFormat data={respnceRow_Ref.current.length > 0 ? respnceRow_Ref.current : []} totalamt={sumOfincome} data2={this.state.isSettleAdviseData} type='settle' pdftitle={`${trainername?.toUpperCase()} ${perams.vendor?.toUpperCase()} SETTLEMENT`} />} fileName="memberlist.pdf">
              {({ blob, url, loading, error }) =>
                loading ? "" : <MdOutlineFileDownload className='member_down_icon' />
              }
            </PDFDownloadLink> */}
            <div className="d-flex justify-content-between align-items-center model_title1">
              <p className='m-0 title-font' style={{ fontSize: '18px' }}>{`PHARMACY SETTLEMENT`}</p>
              <CloseIcon className="rs_close_icon" onClick={this.isSettleAdviseClose}></CloseIcon>
            </div>
            <div style={{ padding: '30px  60px 20px 60px', maxHeight: '500px' }}>
              <div className="scroll-view">
                <div style={{ display: 'flex', fontWeight: 'normal', gap: '10px', justifyContent: 'space-between', alignItems: 'center' }}>
                  <img src={tomImg} style={{ width: '103px', height: '76px' }} />
                  <div className="revenModelTop">
                    {/* <h5 className='m-0'>THE ONE MOMENT</h5> */}
                    <p className='m-0'>UEN NO: 983989849</p>
                    <p className='m-0'>No.222</p>
                    <p className='m-0'>India600060</p>
                  </div>
                </div>
                <div style={{}}>
                  <h2 style={{ textAlign: 'center', margin: '10px 0px 10px 0px', fontSize: '32px', color: '#00000', fontWeight: 'normal' }}>Merchant Settlement Advise - {moment(this.state.isSettleAdviseData?.settlement_date).format('MMM YY')}</h2>
                </div>
                <div style={{ marginBottom: '20px', fontSize: '16px', color: '#212529' }}>
                  <div style={{ display: 'flex', marginBottom: '5px' }}><span style={{ width: '25%' }}>Settlement Number</span><span style={{ width: '5%' }}>:</span><span style={{}}>{this.state.isSettleAdviseData?.settlementID || this.state.isSettleAdviseData?.settlement_no}</span></div>
                  {/* <div style={{ display: 'flex', marginBottom: '5px' }}><span style={{ width: '20%' }}>Date of Settlement</span><span style={{ width: '5%' }}>:</span><span style={{}}>{api.setTomFormat(this.state.isSettleAdviseData.settledDate || this.state.isSettleAdviseData.InitiateDate || this.state.isSettleAdviseData.settlement_date || this.state.isSettleAdviseData.created_date)}</span></div> */}
                  <div style={{ display: 'flex', marginBottom: '5px' }}><span style={{ width: '25%' }}>Merchant Name</span><span style={{ width: '5%' }}>:</span><span style={{}}>{this.state.isSettleAdviseData.vendor_name}</span></div>
                  <div style={{ display: 'flex', marginBottom: '5px' }}><span style={{ width: '25%' }}>Contact Person</span><span style={{ width: '5%' }}>:</span><span style={{}}>{this.state.isSettleAdviseData.vendor_contact}</span></div>
                  <div style={{ display: 'flex', marginBottom: '5px' }}><span style={{ width: '25%' }}>Address</span><span style={{ width: '5%' }}>:</span><span style={{}}>{this.state.isSettleAdviseData.vendor_address}</span></div>
                </div>
                <div className="allkwd_lbl">
                  {/* All values in INR */}
                  {t('all_values_in_kwd')}
                </div>
                <table style={{ width: "100%", border: "1px solid black", margin: '0 auto', fontSize: '16px' }}>
                  <thead>
                    <tr>
                      {this.state.ModelPdfTitle_ref.map((item) => (
                        <th key={item.id} style={{ border: "1px solid black", fontSize: '12px', backgroundColor: "", textAlign: 'center', color: 'black' }}>
                          {item.label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.respnceRow_Ref.map((item, index) => (
                      <tr key={index}>
                        {this.state.ModelPdfTitle_ref.map((header) => (
                          <td key={header.id} style={{ border: "1px solid black", color: 'rgba(0, 0, 0, 0.87)', padding: "2px 5px", textAlign: header.type === 'name' ? 'left' : 'center' }}>
                            {header.type === 'date' ? dateFormat(item[header.id], "dd-mmm-yy") :
                              header.type === 'amt' ? (<div style={{ textAlign: 'right', margin: '0 auto' }}>{(formatMoney(item[header.id]) || 0)}</div>) :
                                item[header.id] ? item[header.id] :
                                  header.label === 'S.No' ? index + 1 : '-'}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className='d-flex justify-content-end' style={{ border: '1px solid', borderWidth: '0px 1px 1px 1px', marginBottom: '20px' }}>
                  <div className='settlementpdfTotal d-flex align-items-center' style={{ background: '#510F30', margin: '8px', fontSize: '12px', padding: '5px', borderRadius: '9px', color: 'white' }}>
                    <div style={{ border: "none", padding: "2px 5px", textAlign: 'center' }}>Net Amount Receivable :</div>
                    <div style={{ textAlign: 'center' }}>{formatMoney(Number(this.state.respnceRow_Ref[this.state.respnceRow_Ref.length - 1]?.balance))}</div>
                  </div>
                </div>
                <div style={{ marginBottom: '30px' }} >
                  <h5 style={{ fontSize: '16px', fontWeight: 'normal' }}>Amount will be transferred by tom on 10th of {moment(this.state.isSettleAdviseData?.settlement_date).add(1, 'month').format('MMM YY')}.</h5>
                  {/* <h6>A total amount of <b>{this.state.respnceRow_Ref[this.state.respnceRow_Ref.length-1]?.balance.toFixed(2)}<span style={{ fontSize: '10px' }}> INR</span> </b> will be credited to your bank account ({this.state.isSettleAdviseData.bank_name} - {this.state.isSettleAdviseData.account_number}) within 2 working days from the
                  date of settlement advise.
                </h6> */}
                  <h5 style={{ fontSize: '16px', fontWeight: 'normal' }}> Please feel free to contact us vide e-mail <b>accounts@theonemoment.com</b> for any queries pertaining to the above
                    settlement advise.</h5>
                </div>
                <div className="mb-5">
                  <h4 style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'normal' }}>THANK YOU FOR YOUR SUPPORT</h4>
                </div>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}
export default withTranslation()(RevenueSettlement);
